import AppProvider from "components/AppProvider";
import { PublishedPage } from "components/PublishedPage";

export default function PublishedPageNextJSPage() {
  return (
    <AppProvider hideProgress skipPageViewEvent>
      <PublishedPage isEmbed={false} />
    </AppProvider>
  );
}
